// @flow
import React, { Component } from "react";
import classNames from "classnames";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";

type QuoteTableRowPropsType = {
  row: Array<*>,
  isBorder?: boolean,
  isLight?: boolean
};

class QuoteTableRow extends Component<QuoteTableRowPropsType, *> {
  render(): * {
    const row = this.props.row; //fixed length 7 or 6
    const isBorder = this.props.isBorder;
    const isLight = this.props.isLight;
    return (
      <TableRow>
        {row.map(
          (item: *, i: number): * => (
            <TableCell
              padding="dense"
              key={i}
              className={classNames(
                "normal",
                isBorder && "border",
                isLight && "medium-light"
              )}
            >
              {row[i]}
            </TableCell>
          )
        )}
      </TableRow>
    );
  }
}

export default QuoteTableRow;
